import { Component, EventEmitter, Input, OnInit, Output, input } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { VendorSearchApi, NotifyService, ChatApi } from 'sustainment-component';

@Component({
    selector: 'app-sign-nda-component',
    templateUrl: './sign-nda.component.html',
    styleUrls: ['./sign-nda.component.scss'],
    standalone: false
})
export class SignNdaComponent implements OnInit {
  @Input() public companyName: string;
  public companyLogo = input.required<string>();
  private _requestId: string | null;
  @Input() public set requestId(value: string | null) {
    this._requestId = value;
    this.loadState();
  }
  @Input() public sustainmentId: string;
  @Input() public receiverSustainmentId: string;
  @Input() public requestedByCurrentUser: boolean;
  @Output() public signedNda = new EventEmitter<string>();
  @Output() public companyClicked = new EventEmitter<void>();
  public isButtonDisabled = true;
  public state: SignatureState | null;

  public constructor(
    private searchVendorsApi: VendorSearchApi,
    private confirmationService: ConfirmationService,
    private notifyService: NotifyService,
    private chatApi: ChatApi
  ) {}

  public ngOnInit(): void {
    this.loadState();
  }

  public loadState(): void {
    if (this._requestId) {
      this.searchVendorsApi
        .getSignatureRequestStatus(this._requestId)
        .subscribe(
          (response) => {
            this.state = response;

            if (response.completed) {
              return;
            } else if (response.pendingOtherParty) {
              this.isButtonDisabled = true;
            } else if (response.signUrl) {
              this.isButtonDisabled = false;
            }
          },
          (error) => {
            throw error;
          }
        );
    }
  }

  public get isLoading(): boolean {
    return !this.state && !!this._requestId;
  }

  public onSignNdaClick(): void {
    window.open(this.state?.signUrl, '_blank');
  }

  public onDeclineNdaClick(): void {
    this.confirmationService.confirm({
      header: `Decline NDA signature`,
      message: `You are going to decline the NDA signature request. Do you wish to continue?`,
      key: 'sign-nda',
      accept: () => {
        this.searchVendorsApi.cancelSignature(this._requestId!).subscribe();

        this._requestId = null;
        this.state = null;
        this.loadState();
        this.notifyService.showSuccess(
          'The NDA signature request has been declined.'
        );

        this.chatApi
          .sendNDAMessage(
            this.sustainmentId,
            this.receiverSustainmentId,
            'canceled'
          )
          .subscribe();
      },
      acceptIcon: 'null',
      acceptLabel: 'Yes, decline',
      rejectLabel: 'Cancel',
      rejectIcon: 'null',
    });
  }

  public companyClick(event: Event): void {
    event.stopPropagation();
    this.companyClicked.emit();
  }
}

export interface SignatureState {
  signUrl: string;
  completed: boolean;
  pendingOtherParty: boolean;
}
